<template>
  <div>
    <div v-if="!genusId">
      <v-btn @click="dialogOpen = true" :disabled="!categoryId" class="orange">{{ $t("select") }}</v-btn>
    </div>

    <div v-else>
      <v-chip
        class="ma-2"
        :close="!readOnly"
        color="#F5F5F5"
        @click:close="selectHandler(null)"
      >{{ name }}</v-chip>
    </div>

    <custom-dialog
      v-if="dialogOpen"
      @close="dialogClose"
      :title="$t('select_flower_genus')"
      hide-actions
    >
      <template v-slot:text>
        <v-text-field
          v-model="searchWord"
          label="品目名をカタカナで入力して検索"
          outlined
        ></v-text-field>
        <v-list style="max-height: 50vh; overflow: auto">
          <div v-for="(array, key) in genusGroups()" :key="key">
            <div class="genusGroupKana">{{ key }}</div>
            <div v-for="genus in array" :key="genus.value">
              <v-list-item @click="selectHandler(genus.value)">
                <v-list-item-content>{{ genus.text }}</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </div>
          <div v-if="Object.keys(genusGroups()).length <= 0">品目が見つかりません。</div>
        </v-list>
      </template>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from "@/components/shared/CustomDialog.vue";

export default {
  components: { CustomDialog },
  props: {
    genusId: {
      type: Number,
      default: null
    },
    categoryId: {
      type: Number,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      dialogOpen: false,
      searchWord: ""
    };
  },
  methods: {
    dialogClose() {
      this.dialogOpen = false;
      this.searchWord = "";
    },
    selectHandler(id) {
      this.dialogOpen = false;
      this.$emit("select", id);
    },
    genusGroups() {
      const options = this.genusOptions;
      if (!options) return [];

      this.optionsCount = options.length - 1;

      const genusGroups = {};
      options.forEach(genus => {
        const genusName = genus.name_furigana;

        const firstChar = this.$sortKana.reverse[genusName.charAt(0)];

        if (!genusGroups[firstChar]) genusGroups[firstChar] = [];

        if (!genusGroups[firstChar].includes(genus)) {
          genusGroups[firstChar].push(genus);
        }
      });

      const keys = Object.keys(genusGroups);
      keys.sort((a, b) => a.localeCompare(b));

      const sortedSpecieGroups = {};
      keys.forEach(x => {
        genusGroups[x].sort((a, b) => a.name_furigana.localeCompare(b.name_furigana));
        sortedSpecieGroups[x] = genusGroups[x];
      });

      return sortedSpecieGroups;
    },
  },
  computed: {
    genusOptions() {
      const genusOptions = this.$store.getters["flowerGenus/options"];
      if (this.searchWord === "") return genusOptions;
      return genusOptions.filter(genus => genus.name_furigana.includes(this.searchWord));
    },
    name() {
      const genus = this.$store.state.flowerGenus.list[this.genusId];

      return genus && genus.name;
    }
  }
};
</script>

<style scoped>
.genusGroupKana {
  background-color: rgb(240, 240, 240);
  padding: 5px;
}
</style>
